import React, {useState} from "react";
import {connect} from "react-redux";
import {NavLink, withRouter} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import NewContactEmailRows from "./components/new-contact-email-rows";
import NewContactPhoneRows from "./components/new-contact-phone-rows";
import NewContactPostalAddressRows from "./components/new-contact-postal-address-rows";
import Avatar from "../../../../../../components/avatar";
import Icon from "../../../../../../components/icon";
import Button from "../../../../../../components/button";
import {
    contactDetailsEditMode,
    postCreateContact
} from '../../../../../../../actions/contactActions';
import {getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions'
import Input from '../../../../../../components/input';
import './index.css';


function NewContactPopup (props) {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const { t } = useTranslation();

    const {
        checkGmailAddOnData,
        selectedContactsGroup,
	    postCreateContact,
        customFieldsForContactForm,
        sharingDetailsPopup,
        customFields
    } = props;

    const {action, contactGivenName, contactFamilyName, contactEmail} = checkGmailAddOnData;
    const goBackToView = () => {
        if(sharingDetailsPopup.length > 0 && sharingDetailsPopup[1].includes('gmail')){
           window.close()
        } else {
            if(selectedContactsGroup.type === "system"){
                props.history.push(`/label/${selectedContactsGroup.id}-${selectedContactsGroup.ownerId}`)
            } else {
                props.history.push(`/label/${selectedContactsGroup.id}`)
            }

        }
    };

    const proceed = (e) => {
        e.preventDefault();

        let labelId = '';

        if(selectedContactsGroup){
            if (checkGmailAddOnData.checkGmailAddon === 'gmailaddon'  && checkGmailAddOnData?.action !=="createNewContact") {
                labelId = selectedContactsGroup;
            } else {
                if(selectedContactsGroup.type === "system"){
                    labelId = "6";
                } else {
                    labelId = selectedContactsGroup.id;
                }
            }
        } else {
            labelId = "6";
        }

        setIsSubmitting(true);

        const {
            prefix,
            givenName,
            middleName,
            familyName,
            suffix,
            company,
            jobTitle,
            description,
            birthday
        } = e.currentTarget.elements;

        let emailValues = [];

        document.querySelectorAll('.new-contact-email-row').forEach(item => {
            emailValues = emailValues.concat({
                "label" : item.children[2].children[0].value,
                "email" : item.children[1].children[0].value
            })
        });

        let phoneValues = [];

        document.querySelectorAll('.new-contact-phone-row').forEach(item => {
            phoneValues = phoneValues.concat({
                "label" : item.children[2].children[0].value,
                "number" : item.children[1].children[0].value
            })
        });

        let postalAddressValues = [];

        document.querySelectorAll('.new-contact-postal-address-row').forEach(item => {

            postalAddressValues = postalAddressValues.concat({
                "street" : item.children[1].children[0].children[0].children[0].value,
	            "neighborhood" : item.children[1].children[0].children[1].children[0].value,
                "postCode" : item.children[1].children[0].children[2].children[0].value,
                "city" : item.children[1].children[1].children[0].children[0].value,
	            "label" : item.children[1].children[1].children[1].children[0].value,
	            "countryCode" : item.children[1].children[2].children[0].children[0].value,
	            "state" : item.children[1].children[2].children[1].children[0].value
            })
        });

        let addableFieldValues = [];

	    document.querySelectorAll('.new-contact-addable-field-row').forEach(item => {
		    addableFieldValues = addableFieldValues.concat({
			    "type" : item.querySelector('.type-field').children[0].value,
			    "category" : item.querySelector('.category-field') ? item.querySelector('.category-field').children[0].value : "",
			    "value" : item.querySelector('.value-field').children[0].value,
		    })
	    });

        let customFieldValues = [];

        document.querySelectorAll('.new-contact-custom-field').forEach((item, index) => {
            if(item.children[1].children[1].value.trim()){
                customFieldValues = customFieldValues.concat({
                    "key" : customFieldsForContactForm.customFields[index].label,
                    "value" : item.children[1].children[1].value.trim()
                })
            }
        });

        let payload = {
            "labels":[ labelId ],
            "imageString":"",
            "phoneContactEntry":{
                "prefix": prefix.value,
                "givenName": givenName.value,
                "middleName": middleName.value,
                "familyName": familyName.value,
                "suffix": suffix.value,
                "company": company.value,
                "jobTitle": jobTitle.value,
                "emailAddresses": emailValues,
                "phoneNumbers": phoneValues,
                "postalAddresses": postalAddressValues,
                "note": description.value,
                "birthday": {
                    "day": birthday.value.split('-')[2],
                    "month": birthday.value.split('-')[1],
                    "year": birthday.value.split('-')[0]
                },
                "userDefined": customFieldValues
            },
        };

	    postCreateContact(
            payload
        )

    };

    return (
        <div className="new-contact">
            {
                selectedContactsGroup && <div className="mb-2">
                    <NavLink to={selectedContactsGroup.type==='system' ? `/label/${selectedContactsGroup.id}-${selectedContactsGroup.ownerId}` : `/label/${selectedContactsGroup.id}`} className="btn-link p-0">
                        <Icon name="long-arrow-left" className="mr-2"/> {t("getBackText")}
                    </NavLink>
                </div>
            }
            <form action="" method="post" autoComplete="off" onSubmit={proceed}>
                <div className="d-flex align-items-center mt-2 mb-4">
                    <Avatar
                        className="mr-3"
                        size={'4em'}
                        src={'https://lh3.googleusercontent.com/a/default-user=s200-p-k-rw-no'}
                    />
                    <h2 className="mb-0">
                        {t("newContactText")}
                    </h2>
                </div>
                <div className="new-contact-body">
                <div className={`d-flex mb-1`}>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label htmlFor="prefix">{t("fieldPrefix")}:</label>
                                <Input
                                    id="prefix"
                                    placeholder={t("fieldPrefix")}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="givenName">{t("fieldFirstName")}:</label>
                                <Input
                                    id="givenName"
                                    placeholder={t("fieldFirstName")}
                                    value={action && contactGivenName}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label htmlFor="middleName">{t("fieldMiddleName")}:</label>
                                <Input
                                    id="middleName"
                                    placeholder={t("fieldMiddleName")}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="familyName">{t("fieldLastName")}</label>
                                <Input
                                    id="familyName"
                                    placeholder={t("fieldLastName")}
                                    value={action && contactFamilyName}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label htmlFor="suffix">{t("fieldSuffix")}:</label>
                                <Input
                                    id="suffix"
                                    placeholder={t("fieldSuffix")}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`d-flex border-top py-3 mb-1`}>
                        <div className="form-group col-md-6">
                            <label htmlFor="company">{t("fieldCompany")}:</label>
                            <Input
                                id="company"
                                placeholder={t("fieldCompany")}
                            />
                        </div>
                        <div className="form-group col-md-6">
                        <label htmlFor="jobTitle">{t("fieldJob")}:</label>
                            <Input
                                id="jobTitle"
                                placeholder={t("fieldJob")}
                            />
                        </div>
                    </div>
                    <NewContactEmailRows email = {action && contactEmail}/>
                    <NewContactPhoneRows/>
                    <NewContactPostalAddressRows/>
                    <div className={`d-flex border-top py-3 mb-1`}>
                        <div className="form-group col-1 d-flex align-items-center justify-content-center">
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path d="M19 14v-4c0-1.1-.9-2-2-2h-4V6.55c.15-.09.29-.18.41-.31.39-.39.59-.92.59-1.42s-.2-1.02-.59-1.41L12
                                 2l-1.41 1.41c-.39.39-.59.91-.59 1.41s.2 1.03.59 1.42c.13.13.27.22.41.31V8H7c-1.1 0-2
                                 .9-2 2v4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM7
                                 10h10v4H7v-4zm12 10H5v-4h14v4z"/></svg>
                        </div>
                        <div className="form-group col-11">
                            <Input
                                type="date"
                                id="birthday"
                            />
                        </div>
                    </div>
                    {
                        customFieldsForContactForm !== null && <div className="new-contact-custom-fields py-4 border-top">
                            {
                                customFieldsForContactForm.customFields.map((item, index) => (
                                    <div key={index} className="d-flex new-contact-custom-field mb-3">
                                        <div className="col-1 d-flex align-items-center justify-content-center">
                                            <svg
                                                height="20"
                                                viewBox="0 -960 960 960"
                                                width="20"
                                            >
                                                <path
                                                    d="M200-520q-33 0-56.5-23.5T120-600v-160q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v160q0 33-23.5 56.5T760-520H200Zm0-80h560v-160H200v160Zm0 480q-33 0-56.5-23.5T120-200v-160q0-33 23.5-56.5T200-440h560q33 0 56.5 23.5T840-360v160q0 33-23.5 56.5T760-120H200Zm0-80h560v-160H200v160Zm0-560v160-160Zm0 400v160-160Z"/>
                                            </svg>
                                        </div>
                                        <div className="col-11">
                                            <p>{item.label}:</p>
                                            {
                                                item.valueType === "TEXT"
                                                    ?
                                                    <>
                                                        <Input
                                                            type="text"
                                                            id={`new-contact-custom-field-key-${index}`}
                                                        />
                                                    </>
                                                    :
                                                    <select
                                                        defaultValue={item.value}
                                                        className="form-control"
                                                        id={`edit-contact-custom-field-value-${index}`}
                                                    >
	                                                    <option value="">---- Select a value ----</option>
                                                        {
                                                            (customFields?.customFields || customFieldsForContactForm?.customFields || []).map((customField) => {
                                                                if (customField.label === item.label) {
                                                                    return customField.dropdownOptions.map((dropdownOption) => (
                                                                        <option key={dropdownOption.id}
                                                                                value={dropdownOption.name}>{dropdownOption.name}</option>
                                                                    ))
                                                                } else {
                                                                    return null
                                                                }
                                                            })
                                                        }
                                                    </select>
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    }
                    <div className="d-flex py-4 border-top">
                        <div
                            className="col-1 d-flex align-items-center justify-content-center">
                            <svg width="20" height="20" viewBox="0 0 24 24">
                                <path fill="none" d="M0 0h24v24H0V0z"/>
                                <path
                                    d="M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"/>
                            </svg>
                        </div>
                        <div className="col-11">
                            <textarea
                                className="form-control"
                                name="description"
                                id="description"
                                rows="3"
                                placeholder={t("fieldDescriptionPlaceholder")}
                            />
                        </div>
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-end w-100 mt-4">
                    {
                        isSubmitting
                            ?
                            <React.Fragment>
                                <Button className="btn-primary font-weight-bold" disabled={true}>
                                    <Icon animated={'pulse'} name="spinner"/>
                                </Button>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                {
                                    selectedContactsGroup && <Button className='btn-outline-primary mr-3'
                                            onClick={goBackToView}>{t("textCancel")}</Button>
                                }
                                <Button className='btn-primary' type='submit'>{t("textSave")}</Button>
                            </React.Fragment>
                    }
                </div>
            </form>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        checkGmailAddOnData: state.profileReducer.setGmailAddOnData,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
        customFieldsForContactForm: state.customFieldsReducer.customFieldsForContactForm,
        customFields: state.customFieldsReducer.customFields
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setContactDetailsEditMode: (boolean) => {
            dispatch(contactDetailsEditMode(boolean))
        },
	    postCreateContact: (object) => {
            dispatch(postCreateContact(object, ownProps))
        },
        getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array))
		}
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewContactPopup));
